<template>
  <div>
    <div class="group-status">
      <template v-for="x in status">
        <div :key="x.index">
          <div class="status">
            <div
              :class="{
                color: true,
                red: x.color == 'แดง',
                yellow: x.color == 'เหลือง',
                pink: x.color == 'ชมพู',
                blue: x.color == 'ฟ้า',
                green: x.color == 'เขียว',
                gray: x.color == 'เทา',
                orange: x.color == 'ส้ม',
                purple: x.color == 'ม่วง',
              }"
            />
            <span style="margin-left:5px;">{{ x.meaning }}</span>
          </div>
        </div>
      </template>
    </div>
    <b-container id="form" fluid>
      <b-row class="px-3">
        <b-col cols="auto" class="px-1px my-1">
          <!--                    <datepicker-->
          <!--                            :minimum-view="'day'"-->
          <!--                            format="d/MM/yyyy"-->
          <!--                            v-model="filter.dateOne"-->
          <!--                            input-class="date-box"-->
          <!--                            clear-button-->
          <!--                            @input="filters(filter)"></datepicker>-->
          <div
            class="datepicker-trigger input-group"
            style="min-width: 150px;"
            @mouseover="activeCloseDate = true"
            @mouseleave="activeCloseDate = false"
          >
            <input
              id="datepicker-trigger"
              class="form-control border-right-0"
              type="text"
              autocomplete="off"
              placeholder="เลือกวันที่"
              :value="formatDates(filter.dateOne, filter.dateTwo)"
            />
            <div class="input-group-prepend bg-white">
              <span
                id="basic-addon1"
                class="input-group-text border-left-0 rounded-right bg-white"
              >
                <fa-icon
                  :style="{
                    opacity: activeCloseDate ? 1 : 0,
                  }"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate"
                />
              </span>
            </div>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger'"
              :mode="'range'"
              :show-shortcuts-menu-trigger="false"
              :fullscreen-mobile="true"
              :date-one="filter.dateOne"
              :date-two="filter.dateTwo"
              @date-one-selected="
                (val) => {
                  filter.dateOne = val;
                }
              "
              @date-two-selected="
                (val) => {
                  filter.dateTwo = val;
                }
              "
              @apply="filters(filter)"
            />
          </div>
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <multiselect
            v-model="filter.direction"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="direction"
            label="direction"
            track-by="id"
            select-label
            deselect-label="✖"
            selected-label
            placeholder="เส้นทางวิ่ง"
            @close="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <multiselect
            v-model="filter.hospital"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="hospital"
            label="name"
            track-by="id"
            select-label
            deselect-label="✖"
            selected-label
            placeholder="สถานพยาบาล"
            @close="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.owner_name"
            type="search"
            class="form-control"
            placeholder="ชื่อเจ้าของ"
            style="min-width: 150px;"
            @input="filter.owner_name === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.hn"
            type="search"
            class="form-control"
            placeholder="HN"
            style="min-width: 150px;"
            @input="filter.hn === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.pet_name"
            type="search"
            class="form-control"
            placeholder="ชื่อสัตว์"
            style="min-width: 150px;"
            @input="filter.pet_name === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.test_name"
            type="search"
            class="form-control"
            placeholder="ชื่อผลตรวจ"
            style="min-width: 150px;"
            @input="filter.test_name === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.daily_number"
            type="search"
            class="form-control"
            placeholder="Daily Number"
            style="min-width: 150px;"
            @input="filter.daily_number === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.ln"
            type="search"
            class="form-control"
            placeholder="LN"
            style="min-width: 150px;"
            @input="filter.ln === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <b-dropdown
            id="dropdown-1"
            text="สถานะ"
            variant="secondary"
            class="m-auto"
          >
            <b-form-group>
              <b-form-checkbox
                v-for="x in status.filter((s) =>
                  [2, 3, 4, 5, 6, 7, 8].includes(s.id)
                )"
                :key="x.id"
                v-model="filter.status_id"
                :value="x.id"
                name="status-filter"
                stacked
                class="mx-3 my-2"
                @change="$nextTick(() => filters(filter))"
                >{{ x.meaning }}</b-form-checkbox
              >
            </b-form-group>
          </b-dropdown>
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <b-dropdown
            id="dropdown-1"
            text="ประเภท Lab"
            variant="secondary"
            class="m-auto"
          >
            <b-form-group>
              <b-form-checkbox
                v-for="x in outLabList"
                :key="x.name"
                v-model="filter.is_out_lab"
                :value="x.value"
                name="out-lab-filter"
                stacked
                class="mx-3 my-2"
                @change="$nextTick(() => filters(filter))"
                >{{ x.name }}</b-form-checkbox
              >
            </b-form-group>
          </b-dropdown>
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <b-dropdown
            id="dropdown-1"
            text="Test Type"
            variant="secondary"
            class="m-auto"
          >
            <b-form-group>
              <b-form-checkbox
                v-for="x in testTypes"
                :key="x.name"
                v-model="filter.test_type"
                :value="x.id"
                name="test-type-filter"
                stacked
                class="mx-3 my-2"
                @change="$nextTick(() => filters(filter))"
                >{{ x.name }}</b-form-checkbox
              >
            </b-form-group>
          </b-dropdown>
        </b-col>
        <b-col cols="auto" class="px-1px my-auto">
          <b-button
            variant="link"
            block
            class="search-icon"
            @click="filters(filter)"
          >
            <fa-icon icon="search" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <!--        <div id="form">-->
    <!--            <form class="flex">-->
    <!--                <div class="select-box">-->
    <!--                    <multiselect-->
    <!--                        :tabindex="-1"-->
    <!--                        v-model="filter.direction"-->
    <!--                        :options="direction"-->
    <!--                        label="direction"-->
    <!--                        track-by="id"-->
    <!--                        selectLabel-->
    <!--                        deselectLabel="✖"-->
    <!--                        selectedLabel-->
    <!--                        placeholder="เส้นทางวิ่ง"-->
    <!--                        @close="filters(filter)"-->
    <!--                    ></multiselect>-->
    <!--                </div>-->
    <!--                <div class="select-box">-->
    <!--                    <multiselect-->
    <!--                        :tabindex="-1"-->
    <!--                        v-model="filter.hospital"-->
    <!--                        :options="hospital"-->
    <!--                        label="name"-->
    <!--                        track-by="id"-->
    <!--                        selectLabel-->
    <!--                        deselectLabel="✖"-->
    <!--                        selectedLabel-->
    <!--                        placeholder="สถานพยาบาล"-->
    <!--                        @close="filters(filter)"-->
    <!--                    ></multiselect>-->
    <!--                </div>-->
    <!--                <div class="date-box">-->
    <!--                    <div class="select-box">-->
    <!--                        <div-->
    <!--                            class="datepicker-trigger input-group"-->
    <!--                            @mouseover="activeCloseDate = true"-->
    <!--                            @mouseleave="activeCloseDate = false"-->
    <!--                        >-->
    <!--                            <input-->
    <!--                                class="form-control border-right-0"-->
    <!--                                type="text"-->
    <!--                                autocomplete="off"-->
    <!--                                id="datepicker-trigger"-->
    <!--                                placeholder="Select dates"-->
    <!--                                :value="-->
    <!--                                    formatDates(filter.dateOne, filter.dateTwo)-->
    <!--                                "-->
    <!--                            />-->
    <!--                            <div class="input-group-prepend bg-white">-->
    <!--                                <span-->
    <!--                                    class="input-group-text border-left-0 rounded-right bg-white"-->
    <!--                                    id="basic-addon1"-->
    <!--                                >-->
    <!--                                    <fa-icon-->
    <!--                                        v-show="activeCloseDate"-->
    <!--                                        :icon="['fas', 'times']"-->
    <!--                                        class="icon"-->
    <!--                                        @click="clearDate"-->
    <!--                                    />-->
    <!--                                </span>-->
    <!--                            </div>-->

    <!--                            <AirbnbStyleDatepicker-->
    <!--                                :trigger-element-id="'datepicker-trigger'"-->
    <!--                                :mode="'range'"-->
    <!--                                :showShortcutsMenuTrigger="false"-->
    <!--                                :fullscreen-mobile="true"-->
    <!--                                :date-one="filter.dateOne"-->
    <!--                                :date-two="filter.dateTwo"-->
    <!--                                @date-one-selected="-->
    <!--                                    val => {-->
    <!--                                        filter.dateOne = val;-->
    <!--                                    }-->
    <!--                                "-->
    <!--                                @date-two-selected="-->
    <!--                                    val => {-->
    <!--                                        filter.dateTwo = val;-->
    <!--                                    }-->
    <!--                                "-->
    <!--                                @apply="filters(filter)"-->
    <!--                            />-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                    &lt;!&ndash; <div class="select-box">-->
    <!--                        <datetime-->
    <!--                            input-class="form-control"-->
    <!--                            class="theme-orange"-->
    <!--                            format="dd-MM-yyyy"-->
    <!--                            v-model="filter.endDate"-->
    <!--                            :min-datetime="filter.startDate"-->
    <!--                            placeholder="end date"-->
    <!--                            v-on:keyup.enter="filters(filter)"-->
    <!--                        ></datetime>-->
    <!--          </div>&ndash;&gt;-->
    <!--                </div>-->
    <!--                <div class="search-box">-->
    <!--                    <div class="search">-->
    <!--                        <input-->
    <!--                            v-model="filter.owner_name"-->
    <!--                            type="search"-->
    <!--                            class="form-control"-->
    <!--                            placeholder="ชื่อเจ้าของ"-->
    <!--                            v-on:keyup.enter="filters(filter)"-->
    <!--                        />-->
    <!--                        <input-->
    <!--                            v-model="filter.hn"-->
    <!--                            type="search"-->
    <!--                            class="form-control"-->
    <!--                            placeholder="HN"-->
    <!--                            v-on:keyup.enter="filters(filter)"-->
    <!--                        />-->
    <!--                        <input-->
    <!--                            v-model="filter.pet_name"-->
    <!--                            type="search"-->
    <!--                            class="form-control"-->
    <!--                            placeholder="ชื่อสัตว์"-->
    <!--                            v-on:keyup.enter="filters(filter)"-->
    <!--                        />-->
    <!--                        <div class="search-icon" @click="filters(filter)">-->
    <!--                            <fa-icon icon="search" />-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </form>-->
    <!--        </div>-->
    <b-table
      :items="items.data"
      :fields="fields"
      striped
      bordered
      responsive
      :tbody-tr-class="rowClass"
    >
      <template slot="no" slot-scope="data">
        <div class="col-right">{{ data.index + items.from }}</div>
      </template>
      <template slot="Daily NO." slot-scope="data">
        <div class="col-right">{{ data.item.daily_number }}</div>
      </template>
      <template slot="LN" slot-scope="data">
        <div class="col-right">
          <a
            @click="
              goResultDetail(
                data.item.id,
                data.item.animal_id,
                data.item.hospital_id,
                true
              )
            "
          >
            <u>{{ data.item.ln }}</u>
          </a>
        </div>
      </template>
      <template slot="วันที่สั่งตรวจ" slot-scope="data">
        <div class="col-center">{{ data.item.order_date }}</div>
      </template>
      <template slot="URGENT" slot-scope="data">
        <div
          :class="{
            'text-red': data.item.emergency_level == 1 ? true : false,
            'text-orange':
              data.item.emergency_level == 1
                ? false
                : data.item.urgency_hospital_type == 'ปกติ'
                ? false
                : true,
            'col-left': true,
          }"
        >
          {{
            data.item.emergency_level == 1 ||
            data.item.urgency_hospital_type == "ด่วน"
              ? `ด่วนพิเศษ`
              : data.item.urgency_hospital_type
          }}
        </div>
      </template>
      <template slot="ชื่อสถานพยาบาล" slot-scope="data">
        <div class="col-left">
          <a @click="goHospitalPage(data.item.hospital_id)">
            <u>{{ data.item.hospital_name }}</u>
          </a>
        </div>
      </template>
      <template slot="ชื่อเจ้าของ" slot-scope="data">
        <div class="col-left">{{ data.item.owner_name }}</div>
      </template>
      <template slot="ชื่อสัตว์" slot-scope="data">
        <div class="col-left">
          <a @click="goAnimalPage(data.item.animal_id, data.item.hospital_id)">
            <u>{{ data.item.animal_name }}</u>
          </a>
        </div>
      </template>
      <template slot="รายการตรวจ" slot-scope="data">
        <template v-for="x in data.item.list_test">
          <div :key="x" class="col-left">
            {{
              data.item.list_test.length - 1 ==
              data.item.list_test.lastIndexOf(x)
                ? x
                : x + " ,"
            }}
          </div>
        </template>
      </template>
      <template slot="SPP" slot-scope="data">
        {{
          data.item.specie_name === "อื่นๆ"
            ? data.item.other_specie
            : data.item.specie_name
        }}
      </template>
      <template slot="สถานะ" slot-scope="data">
        <div
          :class="{
            color: true,
            red: data.item.status_id == '1',
            yellow: data.item.status_id == '2',
            pink: data.item.status_id == '3',
            blue: data.item.status_id == '4',
            green: data.item.status_id == '5',
            gray: data.item.status_id == '6',
            orange: data.item.status_id == '7',
            purple: data.item.status_id == '8',
          }"
        />
      </template>
      <template slot="APPROVE" slot-scope="data">
        <button
          type="button"
          class="btn"
          :class="{
            'btn-secondary': data.item.status_id == 6,
            'btn-primary': data.item.status_id != 6,
            'approve-btn': data.item.status_id != 6,
          }"
          :disabled="data.item.status_id == 6"
          @click="
            goResultDetail(
              data.item.id,
              data.item.animal_id,
              data.item.hospital_id,
              false
            )
          "
        >
          APPROVE
        </button>
      </template>
      <!--            <template slot="REJECT" slot-scope="data">-->
      <!--                <button-->
      <!--                    type="button"-->
      <!--                    class="btn"-->
      <!--                    :class="{-->
      <!--                        'btn-secondary': data.item.status_id == 6,-->
      <!--                        'btn-primary': data.item.status_id != 6,-->
      <!--                        'reject-btn': data.item.status_id != 6-->
      <!--                    }"-->
      <!--                    :disabled="data.item.status_id == 6"-->
      <!--                    @click="-->
      <!--                        goResultDetail(-->
      <!--                            data.item.id,-->
      <!--                            data.item.animal_id,-->
      <!--                            data.item.hospital_id,-->
      <!--                            false-->
      <!--                        )-->
      <!--                    "-->
      <!--                >-->
      <!--                    REJECT-->
      <!--                </button>-->
      <!--            </template>-->
      <template slot="ยกเลิก" slot-scope="data">
        <button
          type="button"
          class="btn"
          :class="{
            'btn-secondary': data.item.status_id == 6,
            'btn-primary': data.item.status_id != 6,
          }"
          :disabled="data.item.status_id == 6"
          @click="showCancelModal(data.item.id)"
        >
          ยกเลิก
        </button>
      </template>
      <template slot="BARCODE" slot-scope="data">
        <button
          type="button"
          class="btn"
          :class="{
            'btn-secondary': data.item.status_id == 6,
            'btn-primary': data.item.status_id != 6,
          }"
          :disabled="data.item.status_id == 6"
          @click="printBarcode(data.item.id)"
        >
          พิมพ์ BARCODE
        </button>
      </template>
    </b-table>
    <div v-if="items.data ? items.data.length <= 0 : true">ไม่พบข้อมูล</div>
    <b-pagination
      v-model="items.current_page"
      size="md"
      :total-rows="items.total"
      :per-page="items.per_page"
      @input="getDataPerPage(items.current_page)"
    />
    <b-modal
      id="myModal"
      ref="cancelModal"
      centered
      title="ยกเลิกสิ่งตรวจ"
      ok-variant="success"
      ok-title="บันทึก"
      cancel-title="ยกเลิก"
      @shown="clearReasonSelect"
    >
      <div class="modal-body">
        <form>
          <div class="form-group">
            <label for="sel1" class="col-form-label left" style="width:100%;"
              >เหตุผล:</label
            >
            <select id="sel1" v-model="reasonSelect" class="form-control">
              <template v-for="val in cancelReason">
                <option v-if="val.reason !== 'อื่นๆ'" :value="val.reason">
                  {{ val.reason }}
                </option>
              </template>
              <option value="อื่นๆ">อื่นๆ</option>
            </select>
          </div>
          <div v-show="reasonSelect == 'อื่นๆ'" class="form-group">
            <label
              for="message-text"
              class="col-form-label left"
              style="width:100%;"
              >อื่นๆโปรดระบุ :</label
            >
            <textarea id="message-text" v-model="reason" class="form-control" />
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn
          class="float-right ml-2"
          variant="success"
          @click="handleOk(selectedIdCancel)"
          >ยืนยัน</b-btn
        >
        <b-btn class="float-right" variant="secondary" @click="hideCancelModal"
          >ยกเลิก</b-btn
        >
      </div>
    </b-modal>
    <notifications group="alert" position="bottom right" />
    <template v-if="listBarcode != []">
      <template v-for="barcode in listBarcode">
        <img v-show="false" :id="'barcode' + barcode" :key="barcode.index" />
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import moment from "moment-timezone";
import format from "date-fns/format";
import Datepicker from "vuejs-datepicker";
import { createPage, createCover } from "../../utils/BarcodeCreate";

export default {
  components: {
    // Datepicker
  },
  data() {
    return {
      activeCloseDate: false,
      fields: [
        "Daily NO.",
        "LN",
        "วันที่สั่งตรวจ",
        // A column that needs custom formatting
        "URGENT",
        "ชื่อสถานพยาบาล",
        // A regular column
        "ชื่อเจ้าของ",
        // A regular column
        "ชื่อสัตว์",
        "SPP",
        "รายการตรวจ",
        "สถานะ",
        // A virtual column made up from two fields
        "BARCODE",
        "APPROVE",
        // "REJECT",
        "ยกเลิก",
      ],
      // filter: {
      //     page_no: "1",
      //     direction: null,
      //     hospital: null,
      //     owner_name: null,
      //     pet_name: null,
      //     hn: null,
      //     dateOne: "",
      //     dateTwo: "",
      //     status_id: "2,3,4,5,6,7,8",
      //     receive: true,
      //     daily_number: '',
      // },
      dateFormat: "D/MM/YYYY",
      reasonSelect: "",
      reason: "",
      selectedCancel: null,
      listBarcode: [],
      outLabList: [
        { name: "In Lab", value: "inLab" },
        { name: "Out Lab", value: "outLab" },
        { name: "ไม่ระบุ", value: "null" },
      ],
    };
  },
  created() {
    // this.setStatus()
  },
  mounted() {
    this.outLabList = [
      ...this.outLabList,
      // ...this.testTypes.map((testType) => ({
      //   name: testType.name,
      //   value: testType.id,
      // })),
    ];
    this.filter.test_type = [...this.testTypes.map((testType) => testType.id)];
    if (!this.filter.dateOne) {
      var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
      // console.log(today);
      this.filter.dateOne = today;
    }
    if (!this.filter.dateTwo) {
      this.filter.dateTwo = today;
    }
    this.filter.page_no = 1;

    this.filters(this.filter);

    this.setRejectReason();
    this.setCancelReason();
  },
  computed: {
    ...mapGetters({
      items: "Order/getDataFromFilter",
      direction: "Direction/getAll",
      hospital: "Hospital/getAll",
      status: "Status/getAll",
      data: "Animal/getData",
      getFilter: "Order/getResultFilter",
      cancelReason: "CancelReason/getAll",
      testTypes: "Test/getTestType",
    }),
    filter: {
      get() {
        return this.getFilter;
      },
      set(value) {
        this.setResultFilter(value);
      },
    },
  },
  methods: {
    // eslint-disable-next-line
    rowClass(item, type) {
      if (item.emergency_level == 1) {
        return "highlight";
      } else {
        return;
      }
    },
    ...mapActions({
      filterOrder: "Order/filterData",
      // setAll: "Order/setAll",
      setResult: "Result/setResult",
      setAnimalData: "Animal/setData",
      setCustomerData: "Hospital/setData",
      updateOrder: "Order/updateOrder",
      setReadOnly: "Order/setReadOnly",
      setAdding: "History/setAdding",
      setRejectReason: "RejectReason/setAll",
      setCancelReason: "CancelReason/setAll",
      checkPermission: "Order/checkPermission",
      setStatus: "Status/setAll",
      setResultFilter: "Order/setResultFilter",
    }),
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error",
        });
        return false;
      }
      return true;
    },
    async goResultDetail(idOut, idAnimal, idHospital, readOnly) {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      let permission = await this.permission("result", "can_view");

      if (permission) {
        this.$store.state.isLoading = true;
        await this.setResult(idOut);
        await this.setAnimalData(idAnimal);
        await this.setCustomerData(idHospital);
        this.setReadOnly(readOnly);
        this.$store.state.isLoading = false;
        this.$router.push({
          name: "result-detail",
          params: { read: readOnly },
        });
      }
      this.$store.state.isLoading = false;
    },
    async filters(obj) {
      this.$store.state.isLoading = true;
      let val = {};
      if (obj.dateTwo == "") {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateOne ? moment(obj.dateOne).format("YYYY-MM-DD") : "",
          status_id: obj.status_id,
          receive: true,
          daily_number: obj.daily_number != null ? obj.daily_number : "",
          ln: obj.ln != null ? obj.ln : "",
          includingApprove:
            obj.lnincludingApprove != null ? obj.includingApprove : false,
          test_name: obj.test_name,
          is_out_lab: obj.is_out_lab ? obj.is_out_lab : null,
          test_type: obj.test_type ? obj.test_type : null,
        };
      } else {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateTwo ? moment(obj.dateTwo).format("YYYY-MM-DD") : "",
          status_id: obj.status_id,
          receive: true,
          daily_number: obj.daily_number != null ? obj.daily_number : "",
          ln: obj.ln != null ? obj.ln : "",
          includingApprove:
            obj.includingApprove != null ? obj.includingApprove : false,
          test_name: obj.test_name,
          is_out_lab: obj.is_out_lab ? obj.is_out_lab : null,
          test_type: obj.test_type ? obj.test_type : null,
        };
      }
      await this.filterOrder(val);
      this.$store.state.isLoading = false;
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate() {
      this.filter.dateOne = "";
      this.filter.dateTwo = "";
      this.filters(this.filter);
    },
    async getDataPerPage(pageNo) {
      this.$store.state.isLoading = true;
      this.filter.page_no = pageNo;
      await this.filters(this.filter);
      this.$store.state.isLoading = false;
    },
    cancelOrder(ln) {
      const payload = {
        id: ln,
        status: "6",
      };
      this.cancelOrder(payload);
    },
    async handleOk(id) {
      if (this.$store.state.isLoading) {
        return;
      }

      this.$store.state.isLoading = true;
      let permission = this.permission("result", "can_cancel");

      if (permission) {
        if (this.reasonSelect == "") {
          this.$swal.fire("โปรดเลือกเหตุผล");
          this.$store.state.isLoading = false;
        } else {
          if (this.reasonSelect == "อื่นๆ" && this.reason == "") {
            this.$swal.fire("โปรดระบุเหตุผล");
            this.$store.state.isLoading = false;
          } else {
            const payload = {
              id,
              status: "6",
              cancel_reason:
                this.reasonSelect == "อื่นๆ" ? this.reason : this.reasonSelect,
            };
            await this.updateOrder(payload);

            this.filters(this.filter);
            this.hideCancelModal();
            this.$store.state.isLoading = false;
          }
        }
      }
      this.$store.state.isLoading = false;
    },
    clearReasonSelect() {
      this.reasonSelect = "";
    },
    hideCancelModal() {
      this.$refs.cancelModal.hide();
    },
    showCancelModal(id) {
      this.selectedIdCancel = id;
      this.reasonSelect = "";
      this.$refs.cancelModal.show();
    },
    async printBarcode(id) {
      if (this.$store.state.isLoading) {
        return;
      }

      this.$store.state.isLoading = true;
      let order = this.items.data.find((item) => item.id === id);

      await this.setAnimalData(order.animal_id);

      this.setListBarcode(order);
      this.exportPdf(order);
      this.$store.state.isLoading = false;
    },
    exportPdf(order) {
      // var doc = new jsPDF({
      //     orientation: "landscape",
      //     unit: "cm",
      //     format: [170.079, 99.2126]
      // });
      var BreakException = {};
      function getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      }

      let pFont = fetch("/Kanit-Regular.ttf")
        .then((response) => response.blob())
        .then((response) => getBase64(response))
        .then((response) => {
          if (!response) {
            return "";
          }
          return response.split(",")[1];
        });

      let pClass = jsPDF;

      Promise.all([pFont, pClass]).then(([font, jsPDF]) => {
        var doc = new jsPDF({
          orientation: "landscape",
          unit: "cm",
          format: [170.079, 99.2126],
        });
        doc.addFileToVFS("/Kanit-Regular.ttf", font);
        doc.addFont("/Kanit-Regular.ttf", "font", "normal");
        doc.setFont("font");
        doc.setFontStyle("normal");
        var width = doc.internal.pageSize.getWidth() - 3;
        var height = doc.internal.pageSize.getHeight() - 1.75;
        for (let index = 0; index < this.listBarcode.length; index++) {
          const img = document.querySelector(
            "img#barcode" + this.listBarcode[index]
          );
          if (index == 0) {
            doc = createCover(
              index,
              doc,
              this.data,
              order,
              this.listBarcode,
              BreakException
            );

            doc = createPage(
              img,
              index,
              doc,
              this.data,
              order,
              this.listBarcode,
              width,
              height,
              BreakException
            );
          } else {
            doc = createPage(
              img,
              index,
              doc,
              this.data,
              order,
              this.listBarcode,
              width,
              height,
              BreakException
            );
          }
        }
        // doc.save('barcode.pdf');
        // doc.autoPrint();
        // doc.output("dataurlnewwindow");
        doc.output("dataurlnewwindow");

        // window.open(doc.output('dataurlnewwindow')).focus();
      });
    },
    async setListBarcode(order) {
      this.listBarcode = [];
      await order.test_order.forEach((element) => {
        if (!this.listBarcode.includes(element.barcode)) {
          this.listBarcode.push(element.barcode);
        }
      });
      this.listBarcode.forEach((element) => {
        JsBarcode("#barcode" + element, element, {
          displayValue: false,
        });
      });
    },
    async goAnimalPage(id, hospitalId) {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      try {
        await this.setAnimalData(id);
        await this.setCustomerData(hospitalId);
      } catch (error) {
        this.$swal.fire("Error", error, "error");
        this.$store.state.isLoading = false;
        return;
      }

      this.$store.state.isLoading = false;

      this.goHistoryAnimalAdding();
    },
    async goHistoryAnimalAdding() {
      const addingCustomer = false;
      const addingAnimal = false;
      this.setAdding({ addingCustomer, addingAnimal });
      let routeData = this.$router.resolve({ name: "history-animal-adding" });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "history-animal-adding" });
    },
    async goHospitalPage(hospitalId) {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      try {
        await this.setCustomerData(hospitalId);
      } catch (error) {
        this.$swal.fire("Error", error, "error");
        this.$store.state.isLoading = false;
        return;
      }

      this.$store.state.isLoading = false;
      this.goHistoryCustomerAdding();
    },
    goHistoryCustomerAdding() {
      const addingCustomer = false;
      const addingAnimal = false;
      this.setAdding({ addingCustomer, addingAnimal });
      let routeData = this.$router.resolve({ name: "history-customer-adding" });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "history-customer-adding" });
    },
  },
};
</script>
<style scoped>
#form {
  background-color: #eaeced;
  padding: 5px;
  /* margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center; */
  /*height: 50px;*/
  /* padding: 0.5rem; */
}
.left {
  text-align: left;
}
.search-box {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.search {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.select-box {
  margin: 0px 5px 0px 5px;
  width: 20vw;
}
.search-icon {
  align-self: center;
  margin: 0px 0px 0px 10px;
  color: black;
}
.flex {
  display: flex;
  margin-right: 10px;
  margin-left: 5px;
}
a {
  color: black;
  cursor: pointer;
}
.text-red {
  color: red;
}
.text-orange {
  color: orange;
}
.date-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 15.5vw;
}
.icon {
  cursor: pointer;
}
.color {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  align-self: center;
  margin: 0 auto;
  justify-content: center;
}
.group-status {
  display: flex;
  margin-bottom: 5px;
}
.status {
  display: flex;
  margin-right: 20px;
}
.red {
  background-color: red;
}
.yellow {
  background-color: #ffe927;
}
.pink {
  background-color: pink;
}
.blue {
  background-color: #00d0ec;
}
.purple {
  background-color: #7202ec;
}
.green {
  background-color: #48e100;
}
.gray {
  background-color: gray;
}
.orange {
  background-color: #fb822b;
}
.approve-btn {
  background-color: #009906;
  border: none;
}
f .reject-btn {
  background-color: #e20000;
  border: none;
}
</style>

<style>
.date-box {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
</style>
